/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DashboardRecordIdentity extends models.RecordIdentity {
    getFixupPrototypeFunction() { return DashboardRecordIdentity.fixupPrototype; }

    static newInstance(model: Partial<DashboardRecordIdentity>): DashboardRecordIdentity {
        let obj = Object.assign(new DashboardRecordIdentity(), model);
        DashboardRecordIdentity.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DashboardRecordIdentity>): DashboardRecordIdentity {
        if (!model) return null;
        return DashboardRecordIdentity.newInstance(<DashboardRecordIdentity> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DashboardRecordIdentity) {
        if (!obj) return;

        models.DashboardRecordIdentity.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DashboardRecordIdentity): boolean {
        if (models.RecordIdentity.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, DashboardRecordIdentity.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Whether the dashboard is shared with the current user
     */
    isShared: boolean;

}
